<template>
  <div class="login-form">
    <form class="login-form__form" @submit.prevent="$emit('loginRequest')">
      <form-input
        :modelValue="v$.form.email.$model.value"
        :field="v$.form.email"
        :isLabelVisible="v$.form.email.$model.isLabelVisible"
        :isValidationRun
        class="login-form__field"
        @update:modelValue="$emit('onValueChange', { field: v$.form.email.$model, value: $event })"
      />

      <form-input
        :modelValue="v$.form.password.$model.value"
        :field="v$.form.password"
        :isLabelVisible="v$.form.password.$model.isLabelVisible"
        :isValidationRun
        class="login-form__field"
        @update:modelValue="
          $emit('onValueChange', { field: v$.form.password.$model, value: $event })
        "
      />

      <p
        v-for="(error, idx) in commonServerErrors"
        :key="idx"
        class="form-hint form-hint--small login-form__field-hint"
        v-html="error.message"
      />

      <div class="login-form__field-actions">
        <slot name="actions" />
      </div>

      <div class="login-form__buttons-wrap">
        <app-button
          class="login-form__button-submit"
          :text="submitButtonText"
          :size="submitButtonSize"
          type="submit"
          :variant="submitButtonVariant"
          :disabled="isLoaderVisible"
        />
      </div>
    </form>
    <loader v-if="isLoaderVisible" :inline="false" />
  </div>
</template>
<script>
import FormInput from '@/components/common/FormInput.vue'

export default {
  name: 'LoginForm',
  components: {
    FormInput,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      required: true,
    },
    isValidationRun: {
      type: Boolean,
      default: false,
    },
    isLoaderVisible: {
      type: Boolean,
      default: false,
    },
    submitButtonText: {
      type: String,
      default: 'Log In',
    },
    submitButtonVariant: {
      type: String,
      default: 'primary',
    },
    submitButtonSize: {
      type: String,
      default: 'sub-middle',
    },
    commonServerErrors: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['loginRequest', 'onValueChange'],
}
</script>
